<div class="third-person-partial-container container">
  <div class="mainWrapper">
    <div class="firstItem">
      <h1>Заказчик перевозки</h1>

      <el-form-item label="Заказчик грузоперевозки" prop="thirdPerson.cargoTransportationCustomer">
        <el-radio-group class="radioGroupButtonsDefault" v-model="dataForm.thirdPerson.cargoTransportationCustomer">
          <el-radio-button v-for="option in optionsWhoPays" :key="option.value" :label="option.label" :value="option.label" />
        </el-radio-group>
      </el-form-item>

      <div class="wrapperPersonTypeInn">
        <el-form-item prop="thirdPerson.typeThirdPerson">
          <el-switch
            @change="handleChangeTypeOfPerson(dataForm.thirdPerson.cargoTransportationCustomer, $event)"
            :disabled="disabledThirdPersonType"
            v-model="dataForm.thirdPerson.typeThirdPerson"
            inactive-text="Физ.лицо"
            active-text="Юр.лицо"
          />
        </el-form-item>
        <el-form-item style="flex: 1; width: 100%" v-if="dataForm.thirdPerson.typeThirdPerson" label="ИНН заказчика" prop="thirdPerson.innThirdPerson">
          <InnAutocomplete v-model:inn="dataForm.thirdPerson.innThirdPerson" @setOrganization="dataForm.thirdPerson.name = $event" />
        </el-form-item>
      </div>

      <el-form-item v-if="dataForm.thirdPerson.typeThirdPerson" label="Наименование организации" prop="thirdPerson.name">
        <OrganizationAutocomplete v-model:organization="dataForm.thirdPerson.name" @setInn="dataForm.thirdPerson.innThirdPerson = $event" />
      </el-form-item>

      <el-form-item class="personContactInfo">
        <el-form-item label="Телефон заказчика" prop="thirdPerson.phoneThirdPerson">
          <el-input v-model="dataForm.thirdPerson.phoneThirdPerson" v-mask="PHONE_MASK" type="tel" :formatter="(value) => `${value}`.replace(/\(89/g, '9')" :placeholder="PHONE_PLACEHOLDER" />
        </el-form-item>

        <el-form-item
          type="email"
          label="Эл. почта"
          prop="thirdPerson.emailThirdPerson"
          :required="dataForm.thirdPerson.typeThirdPerson || dataForm.thirdPerson.cargoTransportationCustomer === 'Получатель'"
        >
          <el-input type="email" autocomplete="email" v-model="dataForm.thirdPerson.emailThirdPerson" />
        </el-form-item>
      </el-form-item>

      <el-form-item class="personFio" label="ФИО заказчика" v-if="!dataForm.thirdPerson.typeThirdPerson" prop="thirdPerson.fioThirdPerson">
        <FIOAutocomplete :onChangeSideEffect="() => ruleFormRef.validateField(['thirdPerson.fioThirdPerson'])" v-model:fio="dataForm.thirdPerson.fioThirdPerson" />
      </el-form-item>
    </div>

    <div class="secondItem">
      <el-form-item prop="thirdPerson.whoPaysCargoTransportation" label="Плательщик за грузоперевозку">
        <el-radio-group class="radioGroupButtonsDefault" v-model="dataForm.thirdPerson.whoPaysCargoTransportation" @change="handleChangePayer('cargoTransportation', $event)">
          <el-radio-button label="Отправитель" value="Отправитель" />
          <el-radio-button label="Получатель" value="Получатель" />
          <el-radio-button label="Третье лицо" :disabled="!dataForm.getThirdPersonAvailable" value="Третье лицо" />
        </el-radio-group>
      </el-form-item>
      <el-form-item prop="thirdPerson.typeOfPaymentCargoTransportation" label="Способ оплаты">
        <el-radio-group @change="handleChangeTypeOfPayment('cargoTransportation', $event)" class="radioGroupButtonsDefault" v-model="dataForm.thirdPerson.typeOfPaymentCargoTransportation">
          <el-radio-button label="Наличные" value="Наличные" />
          <el-radio-button :disabled="checkDisabledAccount(dataForm.thirdPerson.whoPaysCargoTransportation)" label="Расчётный счет юр. лица" value="Расчётный счет юр. лица" />
        </el-radio-group>
      </el-form-item>
    </div>
  </div>

  <div class="bord_button" style="justify-content: flex-end">
    <el-form-item>
      <el-button class="button_send" type="primary" @click="$emit('click-button-next', [ ...getArrayOfRules(dataForm.thirdPerson, 'thirdPerson')])"> Далее </el-button>
    </el-form-item>
  </div>
</div>
